/* biome-ignore-all lint/suspicious/noExplicitAny: legacy code with any types */
import cx from 'classnames';
import {RefObject, useRef} from 'react';
import {useCanvasImage} from '~/common/canvas/hooks/useCanvasImage';
import {FabricArt} from '~/common/fabric/types';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {useCardVideo} from './hooks/useCardVideo';

import './Card.sass';

interface CardImageProps {
  image?: string;
  redirectTo?: string;
  loading?: boolean;
  isMp4?: boolean;
  isGif: boolean;
  backgroundImage: any;
  width: number | string;
  height: number | string;
}

interface BackgroundVideoProps {
  src: string;
  isFree: boolean;
  isLargishAndUp: boolean;
  width: number | string;
  height: number | string;
}

interface UYOVideoProps {
  uyoVideo: any;
  frameImage: any;
  videoStyles: any;
  videoRef: RefObject<HTMLDivElement | null>;
  width?: number | string;
  height?: number | string;
}

export interface CardNewProps {
  fabricArt: FabricArt;
  redirectTo?: string;
  isFree?: boolean;
  width?: number | string;
  height?: number | string;
}

const CardImage = ({image, isGif, backgroundImage, width, height}: CardImageProps) => (
  <img
    id="fabric-card"
    src={image}
    className="animation-card__img"
    style={{
      width: width,
      height: height,
      ...(isGif &&
        backgroundImage?.src && {
          backgroundImage: `url(${backgroundImage?.src})`,
          backgroundSize: '100%',
          backgroundRepeat: 'no-repeat',
        }),
    }}
    alt="Invitation"
  />
);

const BackgroundVideo = ({src, width, height}: BackgroundVideoProps) => (
  <video
    className="animation-card__video"
    autoPlay
    loop
    muted
    playsInline
    style={{width: width, height: height}}
    id="fabric-card__bg-video"
  >
    <source src={src} type="video/mp4" />
  </video>
);

const UYOVideo = ({uyoVideo, frameImage, videoRef, width, height}: UYOVideoProps) => (
  <div className="fabric_user_card--mp4_background" ref={videoRef}>
    {frameImage && (
      <img className="fabric_user_card--mp4_background__frame" src={frameImage.src} alt="" />
    )}
    <video
      className="fabric-user-card__video"
      autoPlay
      loop
      muted
      playsInline
      style={{width: width, height: height}}
    >
      <source src={uyoVideo.src} type="video/mp4" />
    </video>
  </div>
);

export const CardNew = ({
  fabricArt,
  isFree = false,
  width: cardWidth = 0,
  height: cardHeight = 0,
}: CardNewProps) => {
  const videoRef = useRef<HTMLDivElement>(null);
  const isLargishAndUp = useIsLargishAndUp();
  const {
    videoStyles: vStyles,
    isMp4,
    isGif,
    uyoVideo,
    frameImage,
    backgroundImage,
  } = useCardVideo(fabricArt, videoRef);
  const {image, loading} = useCanvasImage(fabricArt);

  const freeWidth = isLargishAndUp ? 'auto' : '100%';
  const width = isFree ? freeWidth : cardWidth;
  const height = isFree ? '100%' : cardHeight;

  const videoStyles = {
    ...vStyles,
    width: width,
  };

  return (
    <div className="animation-card__wrapper">
      <div
        data-qa-id="card-img"
        id="card-img"
        className={cx('animation-card', {
          'container--mp4': isMp4,
        })}
      >
        <CardImage
          image={image}
          loading={loading}
          backgroundImage={backgroundImage}
          isMp4={isMp4}
          isGif={isGif}
          width={width}
          height={height}
        />
        {isMp4 && backgroundImage?.src && (
          <BackgroundVideo
            src={backgroundImage.src}
            isFree={isFree}
            isLargishAndUp={isLargishAndUp}
            width={width}
            height={height}
          />
        )}
        {uyoVideo && (
          <UYOVideo
            uyoVideo={uyoVideo}
            frameImage={frameImage}
            videoStyles={videoStyles}
            videoRef={videoRef}
          />
        )}
      </div>
    </div>
  );
};
